import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {UseMutateFunction} from '@tanstack/react-query';
import Modal from '../../../../incase-domain/components/modals/directory/Modal';
import {
    previewsLoaderSelector,
    selectedPresentationSelector,
    selectedPresentationSlidePreviewsSelector,
} from '../../../../store/selectors/presentation.selectors';
import {ISlide} from '../../../../incase-domain/slide';
import {emittedSlideSelector, selectedSlideSelector} from '../../../../store/selectors/slide.selectors';
import {setEmittedSlideAction, updateSelectedSlideAction} from '../../../../store/actions/slide';
import YellowStarIcon from '../../../../../assets/icons/star-icon-active.svg';
import StarIconGrey from '../../../../../assets/icons/star-icon.svg';
import HideSlideIconActive from '../../../../../assets/icons/HideSlideIconActive.svg';
import HideSlideIcon from '../../../../../assets/icons/HideSlideIcon.svg';
import {updateSelectedPresentationSlidesAction} from '../../../../store/actions/presentation';
import {swapArrayElement} from '../../../../utils/utils';

interface EmittedSlideModalProps {
    emittedSlideModal: boolean;
    cancelEmittedSlideModal: () => void;
    mutateSlide: UseMutateFunction<void, unknown, {slide: ISlide; isRejected?: boolean}>;
}

export default function EmittedSlideModal(props: EmittedSlideModalProps): JSX.Element {
    const {emittedSlideModal, cancelEmittedSlideModal, mutateSlide} = props;

    const {t} = useTranslation();
    const dispatch = useDispatch();

    const selectedPresentation = useSelector(selectedPresentationSelector);
    const selectedSlide = useSelector(selectedSlideSelector);
    const slidePreviews = useSelector(selectedPresentationSlidePreviewsSelector);
    const slide = useSelector(emittedSlideSelector);

    const slideIndex = selectedPresentation.slides.findIndex((slide) => slide._id === slide?._id);

    const acceptChanges = (): void => {
        if (slide) {
            dispatch(updateSelectedSlideAction(slide, slideIndex, false));
            const updatesSlideIndex = selectedPresentation.slides.findIndex((presSlide) => presSlide._id === slide?._id);
            const updatedSlideList = swapArrayElement(selectedPresentation.slides, updatesSlideIndex, slide);
            dispatch(updateSelectedPresentationSlidesAction(updatedSlideList));
        }
        cancelEmittedSlideModal();
        dispatch(setEmittedSlideAction({} as ISlide));
    };

    const rejectChanges = (): void => {
        dispatch(setEmittedSlideAction(selectedSlide));
        mutateSlide({slide: selectedSlide, isRejected: true});
        cancelEmittedSlideModal();
    };

    const previewsLoader = useSelector(previewsLoaderSelector);
    const imgSrc = (slidePreviews || []).find((preview) => preview.slideId === slide?._id)?.imgSrc;
    const getImgSrc = (): string => {
        if (!previewsLoader && imgSrc) return imgSrc;
        return '';
    };

    return (
        <Modal
            isOpen={emittedSlideModal}
            header={t('editorPage.sharePresentations.sharePresentationModal.toastMessage.toastModal.header')}
            onCancel={() => rejectChanges()}
            onConfirm={() => acceptChanges()}
            showConfirm
            showCancel
            confirmText={t('editorPage.sharePresentations.sharePresentationModal.toastMessage.toastModal.accept')}
            cancelText={t('editorPage.sharePresentations.sharePresentationModal.toastMessage.toastModal.reject')}
            size="lg"
        >
            <div className="u-pt-2 u-pb-2" style={{fontSize: '1rem'}}>
                {t('editorPage.sharePresentations.sharePresentationModal.toastMessage.toastModal.info')}
            </div>

            <div className="u-flex u-h-between">
                <div>
                    <span>{slideIndex + 1}.</span>
                    {slide?.name}
                </div>
                <div>
                    <img
                        alt="hide icon"
                        src={slide?.hidden ? HideSlideIconActive : HideSlideIcon}
                        aria-label="Toggle hide slide"
                        style={{height: '20px', color: '#676666'}}
                        className="subNavBar__icons_starSlide"
                    />
                    <img
                        src={slide?.onAutoFavorite ? YellowStarIcon : StarIconGrey}
                        alt="star icon"
                        className="u-pl-2 subNavBar__icons_starSlide"
                        style={{height: '20px'}}
                    />
                </div>
            </div>
            <div className="swiper-slide">
                <div className="c-slidePreviewFooter__slide_image" style={{height: 'auto'}}>
                    <img src={getImgSrc()} alt="" />
                </div>
            </div>
        </Modal>
    );
}
